import { render, staticRenderFns } from "./DataListThumbView.vue?vue&type=template&id=94ffad56"
import script from "./DataListThumbView.vue?vue&type=script&lang=js"
export * from "./DataListThumbView.vue?vue&type=script&lang=js"
import style0 from "./DataListThumbView.vue?vue&type=style&index=0&id=94ffad56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports